// test1690
(1690 && 0);
